"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AutoIdProvider;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var globalId = 0; // By default, if no AutoIdProvider is present, this `globalId` is the ID
// counter. This will work fine for browser-only apps. For SSR support, use
// AutoIdProvider, which will have a scoped counter per request.

var Context = _react["default"].createContext(function () {
  return "svg-id-".concat(globalId++);
});
/**
 * Provide auto generated IDs for the `useId` hook, with support for a custom
 * ID generator. Using this will ensure that each server-side request that
 * renders your app has their own ID counter that starts at 0.
 */


function AutoIdProvider(_ref) {
  var children = _ref.children,
      customGetId = _ref.getId;
  var nextId = (0, _react.useRef)(0);
  var getId = (0, _react.useCallback)(function () {
    return customGetId ? customGetId(nextId) : "svg-id-".concat(nextId.current++);
  }, [customGetId]);
  return _react["default"].createElement(Context.Provider, {
    value: getId
  }, children);
}

AutoIdProvider.Context = Context;
AutoIdProvider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  getId: _propTypes["default"].func
};